import type { EditData } from './types';

type SplitInsert = NonNullable<EditData['splitInserts']>[number];

/** Mesmo seletor para o player e o render. Só um par completo divide a faixa. */
export function splitImagesAtFrame(items: SplitInsert[], frame: number, fps: number, lag = 0): SplitInsert[] {
  const active = items.find((it) => frame >= Math.round(it.start * fps) + lag && frame < Math.round(it.end * fps) + lag);
  if (!active) return [];
  if (!active.group) return [active];
  const pair = items.filter((it) => it.group === active.group && Math.round(it.start * fps) === Math.round(active.start * fps) &&
    Math.round(it.end * fps) === Math.round(active.end * fps) && (it.layout ?? 'top') === (active.layout ?? 'top'));
  if (pair.length !== 2) return [active];
  return pair.sort((a, b) => (a.slot === 'right' ? 1 : 0) - (b.slot === 'right' ? 1 : 0));
}
